export const inArray = (state) => Object.values(state.views);
export const byId = (state) => (id) => state.views[id];
export const count = (state, getters) => getters.inArray.length;

export const activeView = (state) => state.views[state.activeViewId] || null;

export const sortedViews = (state, getters) => getters.inArray.slice().sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
